import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Phone, MapPin, Lock, Camera, Save, Package, Heart, LogOut, Edit2 } from 'lucide-react';
import Header from './components/Header11';
import Footer from './components/Footer11';

const Profile11 = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('profile');
    const [editing, setEditing] = useState(false);
    const [formData, setFormData] = useState({
        fullName: 'Arjun Malhotra', email: 'arjun@example.com', phone: '+91 98765 43210',
        address: '42, MG Road', city: 'Bangalore', state: 'Karnataka', pincode: '560001',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = () => { setEditing(false); };

    const inputStyle = {
        width: '100%', padding: '12px 16px', backgroundColor: '#292524', border: '1px solid #44403C', color: '#FAFAF9',
        fontFamily: "'Source Sans 3', sans-serif", fontSize: '14px', outline: 'none',
    };

    const tabs = [
        { key: 'profile', label: 'Profile', icon: User },
        { key: 'orders', label: 'Orders', icon: Package },
        { key: 'wishlist', label: 'Wishlist', icon: Heart },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Source+Sans+3:wght@300;400;600&display=swap');
            `}</style>

            <div style={{ fontFamily: "'Source Sans 3', -apple-system, sans-serif" }} className="min-h-screen bg-[#1C1917]">
                <Header />

                <main className="pt-[100px] pb-16 px-4 sm:px-6">
                    <div className="max-w-[1000px] mx-auto">
                        {/* Header */}
                        <div className="flex items-center gap-6 mb-8 p-6" style={{ backgroundColor: '#292524', border: '1px solid #44403C' }}>
                            <div className="w-20 h-20 flex items-center justify-center relative" style={{ backgroundColor: '#D97706' }}>
                                <User size={32} style={{ color: '#1C1917' }} />
                                <button className="absolute -bottom-1 -right-1 w-7 h-7 flex items-center justify-center" style={{ backgroundColor: '#1C1917', border: '1px solid #D97706', cursor: 'pointer' }}>
                                    <Camera size={14} style={{ color: '#D97706' }} />
                                </button>
                            </div>
                            <div>
                                <h1 className="text-2xl font-bold" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>{formData.fullName}</h1>
                                <p className="text-sm mt-1" style={{ color: '#A8A29E' }}>{formData.email}</p>
                            </div>
                        </div>

                        {/* Tabs */}
                        <div className="flex gap-0 mb-8" style={{ borderBottom: '1px solid #44403C' }}>
                            {tabs.map(tab => (
                                <button
                                    key={tab.key}
                                    onClick={() => setActiveTab(tab.key)}
                                    className="flex items-center gap-2 px-6 py-3 text-sm"
                                    style={{
                                        background: 'none', border: 'none', cursor: 'pointer',
                                        fontFamily: "'Oswald', sans-serif", fontWeight: 500, letterSpacing: '1px', textTransform: 'uppercase',
                                        color: activeTab === tab.key ? '#D97706' : '#A8A29E',
                                        borderBottom: activeTab === tab.key ? '2px solid #D97706' : '2px solid transparent',
                                    }}
                                >
                                    <tab.icon size={16} /> {tab.label}
                                </button>
                            ))}
                        </div>

                        {/* Profile Tab */}
                        {activeTab === 'profile' && (
                            <div className="p-6" style={{ backgroundColor: '#292524', border: '1px solid #44403C' }}>
                                <div className="flex justify-between items-center mb-6">
                                    <h2 className="text-lg font-semibold" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>PERSONAL DETAILS</h2>
                                    <button onClick={() => editing ? handleSave() : setEditing(true)} className="flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-wider"
                                        style={{ border: '1px solid #D97706', backgroundColor: 'transparent', color: '#D97706', fontFamily: "'Oswald', sans-serif", fontWeight: 500, cursor: 'pointer' }}
                                    >
                                        {editing ? <><Save size={14} /> Save</> : <><Edit2 size={14} /> Edit</>}
                                    </button>
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    {[
                                        { name: 'fullName', label: 'Full Name', icon: User },
                                        { name: 'email', label: 'Email', icon: Mail },
                                        { name: 'phone', label: 'Phone', icon: Phone },
                                        { name: 'address', label: 'Address', icon: MapPin },
                                        { name: 'city', label: 'City', icon: MapPin },
                                        { name: 'state', label: 'State', icon: MapPin },
                                        { name: 'pincode', label: 'PIN Code', icon: MapPin },
                                    ].map(field => (
                                        <div key={field.name}>
                                            <label className="text-xs uppercase tracking-wider mb-2 block" style={{ fontFamily: "'Oswald', sans-serif", fontWeight: 500, color: '#A8A29E' }}>{field.label}</label>
                                            {editing ? (
                                                <input name={field.name} value={formData[field.name]} onChange={handleInputChange} style={inputStyle} />
                                            ) : (
                                                <p className="text-sm py-3 px-4" style={{ color: '#FAFAF9', backgroundColor: '#1C1917', border: '1px solid #44403C' }}>{formData[field.name]}</p>
                                            )}
                                        </div>
                                    ))}
                                </div>
                                <div className="mt-8 pt-6 flex justify-between" style={{ borderTop: '1px solid #44403C' }}>
                                    <button className="flex items-center gap-2 text-xs uppercase tracking-wider" style={{ color: '#A8A29E', background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'Oswald', sans-serif" }}>
                                        <Lock size={14} /> Change Password
                                    </button>
                                    <button onClick={() => navigate('/template11/login')} className="flex items-center gap-2 text-xs uppercase tracking-wider" style={{ color: '#EF4444', background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'Oswald', sans-serif" }}>
                                        <LogOut size={14} /> Logout
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Orders Tab */}
                        {activeTab === 'orders' && (
                            <div className="text-center py-16">
                                <Package size={48} style={{ color: '#44403C', margin: '0 auto 16px' }} />
                                <p className="text-sm mb-4" style={{ color: '#A8A29E' }}>View your complete order history</p>
                                <button onClick={() => navigate('/template11/orders')} className="px-6 py-3 text-sm uppercase tracking-wider" style={{ backgroundColor: '#D97706', border: 'none', color: '#1C1917', fontFamily: "'Oswald', sans-serif", fontWeight: 600, cursor: 'pointer' }}>
                                    View Orders
                                </button>
                            </div>
                        )}

                        {/* Wishlist Tab */}
                        {activeTab === 'wishlist' && (
                            <div className="text-center py-16">
                                <Heart size={48} style={{ color: '#44403C', margin: '0 auto 16px' }} />
                                <p className="text-sm mb-4" style={{ color: '#A8A29E' }}>Your wishlist is empty</p>
                                <button onClick={() => navigate('/template11/shop')} className="px-6 py-3 text-sm uppercase tracking-wider" style={{ backgroundColor: '#D97706', border: 'none', color: '#1C1917', fontFamily: "'Oswald', sans-serif", fontWeight: 600, cursor: 'pointer' }}>
                                    Browse Collection
                                </button>
                            </div>
                        )}
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default Profile11;
